import React from "react";
import { makeStyles } from "@material-ui/core";


let useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: '#F8F7FB',
        width: '100%',
        height: 90,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    content: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    text: {
        fontSize: 20,
        color: '#050A2A',
        marginBottom: 0,
    },
    tell: {
        display: 'inline-block',
        padding: '0 15px',
    }
}))

export default function Index() {

    let classes = useStyles();

    return (
        <div className={classes['root']}>
            <div className={classes['content']}>
                <div>
                    <a href="tel:02191005777">
                        <p className={classes['text']}>
                            <span>
                                مشاوره و پشتیبانی
                            </span>
                            <span className={classes['tell']}>
                                021-91005777
                            </span>
                        </p>
                    </a>
                </div>
                <div>
                    <img src="assets/images/phone.png" alt="" />
                </div>
            </div>
        </div>)
}
